var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazonAlexaBlueLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_210)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4986 0C14.1025 0 -0.000244141 14.1033 -0.000244141 31.5C-0.000244141 47.473 11.8885 60.6676 27.2991 62.7208V56.3735C27.2991 54.5836 26.1703 52.9747 24.4737 52.4059C15.5822 49.4192 9.22154 40.9197 9.45562 30.9688C9.74085 18.8538 19.609 9.32885 31.726 9.45097C43.7987 9.57309 53.548 19.398 53.548 31.5C53.548 31.7758 53.5412 32.0503 53.531 32.3235C53.5286 32.3846 53.5267 32.446 53.5243 32.5075C53.5126 32.7611 53.4971 33.0144 53.4772 33.2662C53.4709 33.3463 53.4632 33.4262 53.4559 33.5057C53.4404 33.6817 53.4224 33.8559 53.4026 34.03C53.3803 34.2284 53.3546 34.4248 53.3269 34.6207C53.3148 34.71 53.3027 34.7996 53.2891 34.8885C50.5895 52.6718 27.4286 62.667 27.3017 62.7213C28.675 62.904 30.0757 63 31.4986 63C48.895 63 62.9975 48.8971 62.9975 31.5C62.9975 14.1033 48.895 0 31.4986 0Z",
    fill: "#5FCAF4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 63
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 63H62.9809V0H0.000244141V63Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_210)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19_210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 64,
    height: 63
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4986 0C14.1025 0 -0.000244141 14.1033 -0.000244141 31.5C-0.000244141 47.473 11.8885 60.6676 27.2991 62.7208V56.3735C27.2991 54.5836 26.1703 52.9747 24.4737 52.4059C15.5822 49.4192 9.22154 40.9197 9.45562 30.9688C9.74085 18.8538 19.609 9.32885 31.726 9.45097C43.7987 9.57309 53.548 19.398 53.548 31.5C53.548 31.7758 53.5412 32.0503 53.531 32.3235C53.5286 32.3846 53.5267 32.446 53.5243 32.5075C53.5126 32.7611 53.4971 33.0144 53.4772 33.2662C53.4709 33.3463 53.4632 33.4262 53.4559 33.5057C53.4404 33.6817 53.4224 33.8559 53.4026 34.03C53.3803 34.2284 53.3546 34.4248 53.3269 34.6207C53.3148 34.71 53.3027 34.7996 53.2891 34.8885C50.5895 52.6718 27.4286 62.667 27.3017 62.7213C28.675 62.904 30.0757 63 31.4986 63C48.895 63 62.9975 48.8971 62.9975 31.5C62.9975 14.1033 48.895 0 31.4986 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.78247 67.7803H67.78V-4.78025H-4.78247V67.7803Z",
    fill: "#5FCAF4"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonAlexaBlueLogo);
export default __webpack_public_path__ + "static/media/Amazon_Alexa_blue_logo.0ab5342d.svg";
export { ForwardRef as ReactComponent };